import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const STORAGE_KEY = "guestVideo42Authorized";

const normalizeValue = (value) => (value || "").trim();

const GuestVideoPage = () => {
  const expectedCode = useMemo(
    () => normalizeValue(process.env.REACT_APP_GUEST_VIDEO_CODE),
    []
  );
  const videoUrl = useMemo(
    () => normalizeValue(process.env.REACT_APP_GUEST_VIDEO_URL),
    []
  );
  const [authorized, setAuthorized] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === "true"
  );
  const [inputCode, setInputCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!expectedCode) {
      setError("Code is not configured.");
      return;
    }

    if (normalizeValue(inputCode) === expectedCode) {
      sessionStorage.setItem(STORAGE_KEY, "true");
      setAuthorized(true);
      setError("");
      return;
    }

    setError("Incorrect code.");
  };

  return (
    <Box sx={{ px: 3, py: 6 }}>
      <Dialog
        open={!authorized}
        disableEscapeKeyDown
        onClose={() => {}}
        aria-labelledby="guest-video-code-title"
      >
        <DialogTitle id="guest-video-code-title">Enter access code</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label="Access code"
              value={inputCode}
              onChange={(event) => setInputCode(event.target.value)}
              error={Boolean(error)}
              helperText={error || " "}
              inputProps={{ "aria-label": "Guest video access code" }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSubmit}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {authorized ? (
        videoUrl ? (
          <Box
            component="video"
            controls
            autoPlay
            preload="metadata"
            controlsList="nodownload noplaybackrate"
            disablePictureInPicture
            onContextMenu={(event) => event.preventDefault()}
            sx={{
              width: "100%",
              maxWidth: 1080,
              borderRadius: 1,
              boxShadow: 3,
            }}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </Box>
        ) : (
          <Typography color="error">
            Guest video URL is not configured.
          </Typography>
        )
      ) : (
        <Typography color="text.secondary">
          This page is protected.
        </Typography>
      )}
    </Box>
  );
};

export default GuestVideoPage;
